import { UserState } from '@contexts/Shared/Authentication';

export enum UserAction {
  USER_FETCHING_DATA_UPDATE = 'USER_FETCHING_DATA_UPDATE',
  USER_FETCH_ERROR_DATA_UPDATE = 'USER_FETCH_ERROR_DATA_UPDATE',
  USER_FETCH_DATA_UPDATE = 'USER_FETCH_DATA_UPDATE',
  USER_SIGN_OUT = 'USER_SIGN_OUT',
}

export type Action = {
  type: UserAction;
  payload: UserState;
};
